import React from 'react';

const TEAM_MEMBERS = [
  {
    id: 1,
    name: 'Ayyan Raza Firdousi',
    role: 'Project Manager',
    image: '/assets/images/project-manager.jpg'
  },
  {
    id: 2,
    name: 'Ashfaq Ahmed',
    role: 'Operation Manager',
    image: '/assets/images/operation-manager.jpg'
  },
  {
    id: 3,
    name: 'Dania Mukhtar',
    role: 'HR Manager',
    image: '/assets/images/hr-manager.jpg'
  }
];

function MeetTeamSection() {
  return (
    <section
      className="meet-team-section"
      style={{
        backgroundImage: "linear-gradient(135deg, rgba(15, 23, 42, 0.31) 0%, rgba(15, 23, 42, 0.23) 100%), url('/assets/images/team-member-bg.jpg')"
      }}
    >
      <div className="container meet-team-container">

        {/* Section Header */}
        <div className="meet-team-header">
          <div className="meet-team-badge">
            <span className="badge-dots">
              <span className="dot dot-red"></span>
              <span className="dot dot-dark"></span>
            </span>
            Our Team
          </div>
          <h2 className="meet-team-title">
            The Masterminds Behind Your Growth
          </h2>
          <p className='max-w-xl'>Our exceptional team has a vision with hands-on expertise that guides every project with precision and care.</p>
        </div>

        {/* Team Cards Grid */}
        <div className="meet-team-grid">
          {TEAM_MEMBERS.map((member) => (
            <div key={member.id} className="team-card">

              {/* Image & Floating Social Bar */}
              <div className="team-card-image-wrapper">
                <img
                  src={member.image}
                  alt={member.name}
                  className="team-card-img"
                />
                <div className="team-img-overlay"></div>

                {/* Floating Right Side Social Bar */}
                <div className="team-social-bar">
                  <a href="#facebook" className="team-social-icon" aria-label="Facebook">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                    </svg>
                  </a>
                  <a href="#twitter" className="team-social-icon" aria-label="X/Twitter">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                    </svg>
                  </a>
                  <a href="#pinterest" className="team-social-icon" aria-label="Pinterest">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z" />
                    </svg>
                  </a>
                  <a href="#instagram" className="team-social-icon" aria-label="Instagram">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* Name & Role Info Box */}
              <div className="team-card-info">
                <h4 className="team-member-name">{member.name}</h4>
                <p className="team-member-role">{member.role}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default MeetTeamSection;
